import Chip from "@mui/material/Chip";
import Stack from "@mui/material/Stack";
import { useTranslation } from "react-i18next";
import { StatusCounts } from "../models/countByStatus";

/**
 * How much of the fleet Geotab answered for, in one line.
 *
 * The report is meant to be checked against real operation, and that check starts with the
 * proportion: a fleet where a third of the vehicles report no consumption is telling you
 * something about the vehicles, not about their fuel use. One vehicle at a time that proportion
 * is invisible.
 */
export function QualitySummary({ counts }: { counts: StatusCounts }) {
  const { t } = useTranslation();

  const chips = [
    {
      key: "failed",
      count: counts.failed,
      label: t("energyReport.summary.failed", "{{count}} Abfrage fehlgeschlagen", {
        count: counts.failed,
      }),
      color: "error" as const,
    },
    {
      key: "missing",
      count: counts.missing,
      label: t("energyReport.summary.missing", "{{count}} ohne Messwerte", {
        count: counts.missing,
      }),
      color: "warning" as const,
    },
    {
      key: "partial",
      count: counts.partial,
      label: t("energyReport.summary.partial", "{{count}} unvollständig", {
        count: counts.partial,
      }),
      color: "warning" as const,
    },
    {
      key: "ok",
      count: counts.ok,
      label: t("energyReport.summary.ok", "{{count}} vollständig", { count: counts.ok }),
      color: "success" as const,
    },
    {
      key: "pending",
      count: counts.pending,
      label: t("energyReport.summary.pending", "{{count}} noch nicht geladen", {
        count: counts.pending,
      }),
      color: "default" as const,
    },
  ];

  return (
    <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
      {chips
        .filter(chip => chip.count > 0)
        .map(chip => (
          <Chip key={chip.key} size="small" variant="outlined" color={chip.color} label={chip.label} />
        ))}
    </Stack>
  );
}
